/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const ChevronLeftIcon = createIcon({
    displayName: 'ChevronLeftIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "M15.345 20c-.905-.823-1.048-.909-1.917-1.742-2.206-2.116-3.463-3.431-5.581-5.755a.748.748 0 0 1 0-1.006c2.114-2.32 3.37-3.635 5.58-5.755.87-.834 1.013-.918 1.918-1.742l1.003 1.102c-.896.815-1.03.89-1.89 1.715A98.482 98.482 0 0 0 9.405 12a98.138 98.138 0 0 0 5.053 5.183c.86.824.994.9 1.89 1.715L15.345 20Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M16.316 22.74c-1.216-1.106-1.407-1.22-2.574-2.34-2.961-2.84-4.648-4.605-7.492-7.725a1.004 1.004 0 0 1 0-1.35c2.838-3.114 4.525-4.88 7.491-7.726 1.168-1.12 1.36-1.233 2.575-2.339l1.346 1.48c-1.202 1.093-1.382 1.195-2.536 2.302-2.714 2.604-4.333 4.281-6.784 6.957 2.456 2.682 4.075 4.36 6.784 6.958 1.154 1.107 1.334 1.21 2.536 2.303l-1.346 1.48Z"
        })
    ]
});
ChevronLeftIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'ChevronLeftIcon'
};
export { ChevronLeftIcon };

//# sourceMappingURL=chevron-left.js.map